import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { endpoints } from '../../../../environments/environment';
import { PixKeyType } from '../models/key-type.enum';
import { PixKey } from '../models/key.model';
import { Observable } from 'rxjs';
import { BaseResult } from '../../../shared/models/base.result.model';
import { PixPaymentFavored } from '../models/payment-favored.model';
import { PixGenerateQrCode } from '../models/generate-qrcode.model';
import { PixQrCode } from '../models/qr-code.model';

@Injectable()
export class PixKeysService {
	private url = endpoints.pix;
	private pixKey: PixKey;
	private pixGenerateQrCode: PixGenerateQrCode;
	private pixQrCode: PixQrCode;

	constructor(private http: HttpClient) { }

	getMain(): Observable<BaseResult<PixKey>> {
		return this.http.get<BaseResult<PixKey>>(this.url.keysMain);
	}

	get(): Observable<BaseResult<PixKey[]>> {
		return this.http.get<BaseResult<PixKey[]>>(this.url.keys);
	}

	post(codigo: string, tipoChave: PixKeyType, CodigoRequisicao: string): Observable<any> {
		return this.http.post<any>(`${this.url.keys}`, {
			codigo: codigo,
			tipoChave: tipoChave,
			CodigoRequisicao: CodigoRequisicao
		});
	}

	delete(codigo: string, tipoChave: PixKeyType, CodigoRequisicao: string): Observable<any> {
		const options = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
			body: {
				codigo: codigo,
				tipoChave: tipoChave,
				CodigoRequisicao: CodigoRequisicao
			},
		};

		return this.http.delete<any>(`${this.url.keys}`, options);
	}

	getAccountByCodeAndType(codigo: string, tipoChave: PixKeyType): Observable<BaseResult<PixPaymentFavored>> {
		return this.http.get<BaseResult<PixPaymentFavored>>(`${this.url.keysAccount}?codigo=${encodeURIComponent(codigo)}&tipoChave=${tipoChave}`);
	}

	getFavoreds(): Observable<BaseResult<PixPaymentFavored[]>> {
		return this.http.get<BaseResult<PixPaymentFavored[]>>(this.url.keysFavorite);
	}

	postFavored(favored: PixPaymentFavored): Observable<any> {
		return this.http.post<any>(this.url.keysFavorite, favored);
	}

	deleteFavored(codigoSequencial: string): Observable<any> {
		return this.http.delete<any>(`${this.url.keysFavorite}/${codigoSequencial}`);
	}

	postValidate(codigo: string, tipoChave: PixKeyType): Observable<any> {
		return this.http.post<any>(`${this.url.keysValidate}`, {
			Codigo: codigo,
			TipoChave: tipoChave
	 });
 	}

	putValidade(codigo: string, tipoChave: PixKeyType, CodigoRequisicao: string, code: string): Observable<any> {
		return this.http.put<any>(`${this.url.keysValidate}/${code}`, {
			Codigo: codigo,
			TipoChave: tipoChave,
			CodigoRequisicao: CodigoRequisicao
	 	});
  }

	getQrCode(pixGenerateQrCode: PixGenerateQrCode): Observable<any> {
		return this.http.post<any>(`${this.url.qrcode}`, pixGenerateQrCode);
 	}

	setPixKey = (pixKey: PixKey) => this.pixKey = pixKey;
	getPixKey = (): PixKey => this.pixKey;
	setPixGenerateQrCode = (pixGenerateQrCode: PixGenerateQrCode) => this.pixGenerateQrCode = pixGenerateQrCode;
	getPixGenerateQrCode = (): PixGenerateQrCode => this.pixGenerateQrCode;
	setPixQrCode = (pixQrCode: PixQrCode) => this.pixQrCode = pixQrCode;
	getPixQrCode = (): PixQrCode => this.pixQrCode;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/keys/keys.service.ts